export enum CardIntent {
  CHARGE = 'CHARGE',
  CHARGE_AND_STORE = 'CHARGE_AND_STORE',
  STORE = 'STORE',
}

// derived from all distinct values in the spree_credit_cards.cc_type column
export enum CardBrands {
  AMEX = 'AMERICAN_EXPRESS',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
  UNION_PAY = 'UNION_PAY',
  DISCOVER_DINERS = 'DISCOVER_DINERS',
  OTHER = 'OTHER',
  SQUARE_GIFT_CARD_V2 = 'SQUARE_GIFT_CARD_V2',
  OTHER_BRAND = 'OTHER_BRAND',
  CHINA_UNIONPAY = 'CHINA_UNIONPAY',
  SQUARE_GIFT_CARD = 'SQUARE_GIFT_CARD',
}

// These mirror CardInputEventTypes from @square/web-payments-sdk-types
export enum CardEvents {
  FOCUS_CLASS_ADDED = 'focusClassAdded',
  FOCUS_CLASS_REMOVED = 'focusClassRemoved',
  ERROR_CLASS_ADDED = 'errorClassAdded',
  ERROR_CLASS_REMOVED = 'errorClassRemoved',
  POSTAL_CODE_CHANGED = 'postalCodeChanged',
}
